import type { RegistrationProductWaitinglistPriorityRulesPlugin } from '@adornis/buchungsheld-db/db-plugins.js';
import { PriorityTestRule } from '@adornis/buchungsheld-db/entities/ProductWaitinglistPriorityRule.js';

export const testRegistrationProductWaitinglistPriorityRulesPlugin: RegistrationProductWaitinglistPriorityRulesPlugin =
  {
    id: 'registration::product-waitinglist-priority-rules::test',
    type: 'registration::product-waitinglist-priority-rules',
    getRuleKinds() {
      return [PriorityTestRule];
    },
    blockTimeForLowPriorityInDays: 3,
  };
